// Runs once even if the script is loaded more than once
(function () {
  if (window.__extendIntegrationInitialized) return;
  window.__extendIntegrationInitialized = true;

  // Pauses cart normalization while a PDP add-to-cart is in flight, so the plan
  // isn't removed as an orphan before its covered product reaches the cart.
  let suppressCartNormalize = false;

  // ! ||--------------------------------------------------------------------------------||
  // ! ||                                   PDP Offers                                   ||
  // ! ||--------------------------------------------------------------------------------||

  /**
   * Returns a variant's price in cents from meta, or null when not found.
   */
  function getVariantPrice(variantId) {
    if (!meta || !meta.product || !meta.product.variants) return null;
    const variant = meta.product.variants.filter(
      (v) => v.id == variantId,
    )[0];
    return variant ? variant.price : null;
  }

  class ExtendProductOffer extends HTMLElement {
    constructor(container, variantInput, addToCartButton) {
      super();

      this.container = container;
      this.variantInput = variantInput;
      this.addToCartButton = addToCartButton;

      const referenceId = variantInput.value;
      const price = getVariantPrice(referenceId);
      const category = meta.product.type;

      this.params = {
        referenceId,
        price,
        category,
      };

      this.config = getConfiguration();
      this.config.dispatchSideCart = false;
    }

    connectedCallback() {
      try {
        this.verifyProductOffer();
      } catch (err) {
        console.error(err.message);
        return;
      }

      this.bindEvents();
      this.style.display = "block";

      if (!this.config.pdpOfferEnabled) this.style.display = "none";
      // Renders Extend offer
      Extend.buttons.render(this, this.params, () => {
        setTimeout(() => {
          window.dispatchEvent(new Event("resize"));
        }, 250);
      });
    }

    bindEvents() {
      this.handleAddToCart = this.handleAddToCart.bind(this);
      this.handleVariantChange = this.handleVariantChange.bind(this);

      document.addEventListener("click", this.handleAddToCart, true);

      // Fires on variant/swatch selection
      this.container.addEventListener("change", this.handleVariantChange, true);

      // Fires when the variant input's value attribute changes
      try {
        this.variantObserver = new MutationObserver(this.handleVariantChange);
        this.variantObserver.observe(this.variantInput, {
          attributes: true,
          attributeFilter: ["value"],
        });
      } catch (err) {
        /* MutationObserver unavailable */
      }
    }

    verifyProductOffer() {
      let elementsToCheck = [
        "this.container",
        "this.variantInput",
        "this.addToCartButton",
        "this.params.referenceId",
        "this.params.price",
        "this.params.category",
      ];

      let missingElements = elementsToCheck.filter((value) => {
        try {
          return !eval(value);
        } catch (err) {
          return true;
        }
      });

      if (missingElements.length) {
        let message = "The following value(s) are null or undefined:\n";
        missingElements.forEach((value) => {
          message += `\t${value}\n`;
        });
        throw new ExtendError(message);
      }

      // Checks if Extend lives in the window and the active currency is USD before showing Extend offers
      verifyExtend();
    }

    modalDone() {
      // remove default click listener
      document.removeEventListener("click", this.handleAddToCart, true);

      // Resume normalization only after the covered product is confirmed in the cart
      const referenceId = this.params.referenceId;
      const deadline = Date.now() + 12000;
      const settle = () => {
        getCart().then((currentCart) => {
          const productInCart = currentCart.items.some(
            (item) => item.variant_id == referenceId,
          );
          if (productInCart || Date.now() > deadline) {
            suppressCartNormalize = false;
            initCartOffer();
          } else {
            document.addEventListener("booster:cart:update", settle, {
              once: true,
            });
          }
        });
      };
      document.addEventListener("booster:cart:update", settle, { once: true });

      // click atc button
      this.addToCartButton.click();
      // add default click listener back
      document.addEventListener("click", this.handleAddToCart, true);
    }

    /**
     * Handle add to cart event with offers
     * @param {PointerEvent} e Click event from Add To Cart Button
     */
    handleAddToCart(e) {
      const clickedButton =
        e.target && e.target.closest ? e.target.closest("button") : null;
      if (clickedButton !== this.addToCartButton) return;

      e.preventDefault();
      e.stopImmediatePropagation();

      const quantityEl = this.container.querySelector('[name="quantity"]');
      const quantity = quantityEl && quantityEl.value ? quantityEl.value : 1;

      // Hold normalization until the product lands in the cart (see modalDone)
      suppressCartNormalize = true;

      ExtendShopify.handleAddToCart(this, {
        quantity: quantity,
        modal: this.config.offerModalEnabled,
        done: this.modalDone.bind(this),
      });
    }

    handleVariantChange() {
      const newReferenceId = this.variantInput.value;
      if (!newReferenceId || newReferenceId === this.params.referenceId) return;

      this.params.referenceId = newReferenceId;
      this.params.price = getVariantPrice(newReferenceId);

      Extend.setActiveProduct(this, this.params);
      setTimeout(() => {
        window.dispatchEvent(new Event("resize"));
      }, 250);
    }
  }
  if (!customElements.get("extend-offer"))
    customElements.define("extend-offer", ExtendProductOffer);

  /**
   * Initializes product offers and handles ATC button functionality for the main PDP ATC
   */
  function initProductOffer() {
    try {
      if (meta.page.pageType != "product" || !meta.product)
        throw new ExtendError(
          "Extend Product Offer - The current page is not a product page",
        );
    } catch (err) {
      console.warn(err.message);
      return;
    }

    const container =
      document.querySelector(".product__atc") ||
      document.querySelector("[data-bstr-variant-input]")?.closest("div");
    const variantInput = container
      ? container.querySelector('[name="id"]') ||
      container.querySelector("[data-bstr-variant-input]")
      : document.querySelector('[name="id"]');
    const addToCartButton = container
      ? container.querySelector("button[data-buy-button]") ||
      container.querySelector('button[type="submit"]')
      : document.querySelector("button[data-buy-button]");

    if (!container || !variantInput || !addToCartButton) {
      console.warn(
        "EXTEND: Could not locate the Booster product ATC (.product__atc), variant input, or buy button — PDP offer skipped",
      );
      return;
    }

    // Create offer and render it just above the add-to-cart button
    const extendOffer = new ExtendProductOffer(
      container,
      variantInput,
      addToCartButton,
    );

    const offerElement = document.querySelector('.product__atc ');

    offerElement.parentElement.insertBefore(extendOffer, offerElement);
  }

  // ! ||--------------------------------------------------------------------------------||
  // ! ||                                   Cart Offers                                  ||
  // ! ||--------------------------------------------------------------------------------||

  const cartOfferTag = "extend-cart-offer";

  class ExtendCartOffer extends HTMLElement {
    constructor(referenceId, category, price, quantity, type) {
      super();
      this.params = {
        referenceId,
        category,
        price,
        quantity,
      };
      this.type = type;

      this.config = getConfiguration();
    }

    connectedCallback() {
      if (!this.canDisplayOffer()) {
        return;
      }

      Extend.buttons.renderSimpleOffer(this, {
        ...this.params,
        onAddToCart: ({ plan, product }) => {
          ExtendShopify.addPlanToCart(
            {
              plan,
              product,
              quantity: this.params.quantity,
            },
            (err) => {
              if (err) {
                throw new ExtendError(err.message);
              }

              document.dispatchEvent(
                new CustomEvent("extend.plan-update", {
                  detail: { offer: this },
                }),
              );
            },
          );
        },
      });
    }

    canDisplayOffer() {
      return (
        (this.type === "main" && this.config.cartOfferEnabled) ||
        (this.type === "side" && this.config.sideCartOfferEnabled)
      );
    }
  }
  if (!customElements.get(cartOfferTag))
    customElements.define(cartOfferTag, ExtendCartOffer);

  const initCartOffer = (() => {
    var cart;
    var init = false;

    const {
      cartOfferEnabled,
      cartSPEnabled,
      sideCartOfferEnabled,
      cartBalancingEnabled,
      SPEnabled,
    } = getConfiguration();

    let type, selectors, pageType;

    // Resolves the cart type and selectors from the current page
    function resolveCartContext() {
      try {
        pageType = meta.page.pageType;
      } catch (err) {
        pageType = undefined;
      }

      if (pageType === "cart" && (cartOfferEnabled || cartSPEnabled)) {
        // Cart page (sections/cart-page.liquid)
        selectors = {
          cartContainer: ".section--cart-page", // Section wrapper
          cartRowItem: ".cart__item", // Container element for each item in the cart
          cartRowItemImage: ".minicart__image", // Product image anchor element
          cartRowItemTitle: ".cart__info--text a", // Title anchor element for the product
          cartRowItemQuantity: "input[data-qty-input]", // Input element containing the product quantity
          warrantyOriginalMeta: ".product-option", // Line item property nodes
          offerAnchor: ".cart__info--text", // Container where the offer will be appended
          metadataContainer: "dl", // Where warranty metadata will be appended
          variationClass: "cart__info--variant", // Span class used for the plan metadata
          quantityWrapper: ".quantity--input", // Wrapper for quantity input and buttons
        };
        type = "main";
      } else if (sideCartOfferEnabled) {
        // Mini-cart drawer, rendered into [data-product-list] (sections/api__minicart.liquid)
        selectors = {
          cartContainer: "[data-product-list]",
          cartRowItem: ".minicart__entry",
          cartRowItemImage: ".minicart__image", // Product image element
          cartRowItemTitle: ".minicart__info a", // Title anchor element for the product
          cartRowItemQuantity: "input[data-qty-input]", // Input element containing the product quantity
          warrantyOriginalMeta: ".minicart__variation", // Variation metadata node
          offerAnchor: ".minicart__info", // Container where the offer will be appended
          metadataContainer: "", // No metadata list in the mini-cart
          variationClass: "minicart__variation", // Span class used for the plan metadata
          quantityWrapper: ".quantity--input", // Wrapper for quantity input and buttons
          lineItemRemove: ".minicart__trash",
        };
        type = "side";
      }
    }

    function createWarrantyOffer(lineItemElement, index) {
      if (!cartOfferEnabled && type === "main") return;
      if (!sideCartOfferEnabled && type === "side") return;

      const anchor = lineItemElement.querySelector(selectors.offerAnchor);
      if (!anchor) {
        throw new ExtendError(
          `Offer anchor element on line ${index} not found with selector ${selectors.offerAnchor}`,
        );
      }

      const container = anchor.querySelector("div[extend-bundle-offer]");

      const cartItem = cart.items[index];
      const referenceId = container
        ? container.dataset.referenceId
        : cartItem.variant_id;
      const quantity = container ? container.dataset.quantity : cartItem.quantity;
      const price = container ? container.dataset.price : cartItem.price;
      const category = container
        ? container.dataset.category
        : cartItem.product_type;
      const warrantyAlreadyInCart =
        ExtendShopify.warrantyAlreadyInCart(referenceId, cart.items) ||
        ExtendShopify.warrantyAlreadyInCart(referenceId.toString(), cart.items);

      const extendOffer = lineItemElement.querySelector(cartOfferTag);

      // If there's already an offer element, check that the properties match what we are trying to create
      // If they do not match, or the warranty is already in cart, remove the offer
      if (extendOffer) {
        if (
          extendOffer.params.referenceId !== referenceId ||
          extendOffer.params.quantity !== quantity ||
          extendOffer.params.price !== price ||
          extendOffer.params.category !== category ||
          warrantyAlreadyInCart
        ) {
          extendOffer.remove();
          // If they do match and the warranty is not already in the cart, do not create a new offer
        } else {
          return;
        }
        // If there is no offer element, but the warranty is already in cart, do not create a new offer
      } else if (warrantyAlreadyInCart) {
        return;
      }

      const newExtendOffer = new ExtendCartOffer(
        referenceId,
        category,
        price,
        quantity,
        type,
      );

      // Side cart: place the offer above the quantity stepper; otherwise append
      const quantityWrapper = anchor.querySelector(selectors.quantityWrapper);
      if (type === "side" && quantityWrapper) {
        anchor.insertBefore(newExtendOffer, quantityWrapper);
      } else {
        anchor.append(newExtendOffer);
      }
    }

    function styleWarrantyLineItem(lineItemElement, index) {
      const title = lineItemElement.querySelector(selectors.cartRowItemTitle);
      if (title) {
        title.style.pointerEvents = "none";
        title.innerText = "Extend Protection Plan";
      }

      const image = lineItemElement.querySelector(selectors.cartRowItemImage);

      if (image) {
        image.style.pointerEvents = "none";
      } else {
        console.error(
          `EXTEND: Line item image element on line ${index} not found with selector ${selectors.cartRowItemImage}`,
        );
      }

      // Remove the theme's original variation node — a warranty variant title
      // renders as a stray price-like value.
      lineItemElement
        .querySelectorAll(`.${selectors.variationClass}`)
        .forEach((node) => {
          if (!node.classList.contains("extend-warranty-info")) node.remove();
        });

      // Booster doesn't render line-item properties, so build the plan metadata
      // (covered product + term) from the line item and style it like a variation.
      const properties = (cart.items[index] && cart.items[index].properties) || {};

      let productName = properties["Product"];
      if (productName === "Covered Product") {
        const productId = properties["_Extend.ProductId"];
        const covered = cart.items.filter((item) => {
          const id = item.variant_id || item.id || item.variantId;
          return id != null && id.toString() == productId;
        })[0];
        if (covered) productName = covered.product_title || covered.title;
      }

      const metadata = [];
      if (productName) metadata.push(`Product: ${productName}`);
      if (properties["Term"]) metadata.push(`Term: ${properties["Term"]}`);

      if (title && !lineItemElement.querySelector(".extend-warranty-info")) {
        let refNode = title;
        metadata.forEach((text) => {
          const span = document.createElement("span");
          span.className = `${selectors.variationClass} extend-warranty-info`.trim();
          span.textContent = text;
          refNode.insertAdjacentElement("afterend", span);
          refNode = span;
        });
      }

      if (
        selectors.quantityWrapper?.length &&
        lineItemElement.querySelector(selectors.quantityWrapper)
      ) {
        lineItemElement
          .querySelectorAll(selectors.quantityWrapper)
          .forEach((each) => {
            each.style.opacity = "75%";
            each.style.pointerEvents = "none";
          });
      }
    }

    function formatLineItems() {
      let cartContainer = document.querySelector(selectors.cartContainer);

      if (!cartContainer) {
        throw new ExtendError(
          `Invalid cart container selector: ${selectors.cartContainer}`,
        );
      }

      cartContainer
        .querySelectorAll(selectors.cartRowItem)
        .forEach((lineItemElement, index) => {
          let title = lineItemElement.querySelector(selectors.cartRowItemTitle);

          if (!title) {
            console.warn(
              `EXTEND: Line item title not found on line ${index} with selector ${selectors.cartRowItemTitle} — skipping`,
            );
            return;
          }

          let lowerCaseTitle = title.innerHTML.toLowerCase();

          if (lowerCaseTitle.includes("extend protection")) {
            styleWarrantyLineItem(lineItemElement, index);
          } else {
            createWarrantyOffer(lineItemElement, index);
          }
        });
    }

    function normalizeItems(callback) {
      getCart()
        .then((newCart) => {
          const cartContainer = document.querySelector(selectors.cartContainer);
          const bundleOffers = cartContainer
            ? cartContainer.querySelectorAll("div[extend-bundle-offer]")
            : [];
          bundleOffers.forEach((bundle) => {
            newCart.items[bundle.dataset.cartIdx].variant_id =
              bundle.dataset.referenceId;
          });
          return newCart;
        })
        .then((newCart) => {
          if (SPEnabled) {
            ExtendShopify.updateExtendLineItems({
              balanceCart: cartBalancingEnabled,
              isSPSupported: cartSPEnabled,
              callback,
            });
          } else {
            let normalizationOpts = {
              balance: cartBalancingEnabled,
              cart: newCart,
            };
            ExtendShopify.normalizeCart(normalizationOpts, callback);
          }
        });
    }

    function refreshCart() {
      if (type === "side") {
        // Trigger Booster to re-render the mini-cart
        try {
          BoosterTheme.events.trigger("booster:cart:update", {
            source: "extend-cart",
          });
        } catch (err) {
          document.dispatchEvent(
            new CustomEvent("booster:cart:update", {
              detail: { source: "extend-cart" },
            }),
          );
        }
      } else {
        location.reload();
      }
    }

    function verifyCartOffers() {
      verifyExtend();

      let error = "";
      if (!selectors) error = `Cart selectors are empty\n`;

      if (!type) error += `Cart type not defined\n`;

      if (error.length > 0) {
        throw new ExtendError(
          `Cannot initialize cart offers due to following errors:\n${error}`,
        );
      }
    }

    function initEventListeners() {
      if (type === "main") {
        // Re-inject offers after the cart section re-renders
        document.addEventListener("booster:content:update", (event) => {
          const detail = event.detail || {};
          if (!detail.trigger || detail.trigger === "cart-page") {
            onCartUpdate();
          }
        });
      } else {
        // Re-inject offers when the cart changes
        document.addEventListener("booster:cart:update", (event) => {
          const detail = event.detail || {};
          if (detail.source === "extend-cart") return;
          onCartUpdate();
        });
        document.addEventListener("booster:content:update", () => {
          onCartUpdate();
        });
      }

      document.addEventListener("extend.plan-update", refreshCart);

      init = true;
    }

    function onCartUpdate() {
      if (suppressCartNormalize) return;
      normalizeItems((err, data) => {
        cart = data.cart;
        if (err) {
          throw new ExtendError(err);
        }

        if (data?.updates) {
          refreshCart();
        }

        formatLineItems();
      });
    }

    return function initCartOffer() {
      resolveCartContext();
      verifyCartOffers();

      try {
        if (
          pageType !== "cart" &&
          !/cart/.test(window.location.pathname) &&
          !sideCartOfferEnabled
        ) {
          throw new ExtendError("Cannot initialize cart offers - not a cart page");
        }
      } catch (err) {
        console.warn(err.message);
        return;
      }

      if (!init) initEventListeners();

      if (document.querySelector(selectors.cartContainer)) {
        onCartUpdate();
      }
    };
  })();

  // ! ||--------------------------------------------------------------------------------||
  // ! ||                                      Utils                                     ||
  // ! ||--------------------------------------------------------------------------------||
  class ExtendError extends Error {
    constructor(message) {
      super(message);
    }
  }

  function getConfiguration() {
    return {
      currency: "USD",
      pdpOfferEnabled: true,
      offerModalEnabled: true,
      cartOfferEnabled: true,
      sideCartOfferEnabled: true,
      cartBalancingEnabled: true,
      aftermarketModalEnabled: true,
      atcOfferEnabled: true,
      quickviewOfferEnabled: false,
      quickviewModalOfferEnabled: false,
      cartSPEnabled: false,
      SPEnabled: false,
    };
  }

  function verifyExtend() {
    const propertiesToCheck = [
      "window.Extend",
      "window.ExtendShopify",
      "window.Shopify",
      "window.Shopify.currency.active",
    ];

    function checkPropertyExists(path) {
      return (
        path.split(".").reduce((obj, prop) => obj && obj[prop], window) !==
        undefined
      );
    }

    let errors = propertiesToCheck.filter((prop) => !checkPropertyExists(prop));

    // Check for currency mismatch
    if (window.Shopify?.currency?.active !== getConfiguration().currency) {
      errors.push("window.Shopify.currency.active == config.currency");
    }

    if (errors.length) {
      let message = "The following value(s) are null, undefined, or false:\n";
      errors.forEach((error) => {
        message += `\t${error}\n`;
      });
      throw new ExtendError(message);
    }
  }

  function initAftermarket() {
    try {
      verifyExtend();

      // Get params from URL
      const params = new URL(document.location).searchParams;

      // Check if leadToken or leadtoken is in the URL
      let leadToken = params.get("leadToken")
        ? params.get("leadToken")
        : params.get("leadtoken");

      if (leadToken) {
        Extend.aftermarketModal.open({
          leadToken: leadToken,
          onClose: function (plan, product, quantity) {
            if (plan && product) {
              ExtendShopify.addPlanToCart(
                {
                  plan: plan,
                  product: product,
                  leadToken: leadToken,
                  quantity: quantity || 1,
                },
                function () {
                  location = "/cart";
                },
              );
            }
          },
        });
      }
    } catch (error) {
      throw new ExtendError(error.message);
    }
  }

  function getCart() {
    return fetch("/cart.js", {
      credentials: "same-origin",
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
    }).then((e) => e.json());
  }

  // Integration init
  window.addEventListener("extend.integration", () => {
    try {
      const storeId = "72578ac5-b6f8-407e-a7d5-17c40219a306";
      const environment = "production";

      window.Extend.config({ storeId, environment });

      const config = getConfiguration();

      if (config.aftermarketModalEnabled) initAftermarket();

      if (
        config.atcOfferEnabled ||
        config.offerModalEnabled ||
        config.pdpOfferEnabled
      )
        initProductOffer();

      if (
        config.cartOfferEnabled ||
        config.cartSPEnabled ||
        config.sideCartOfferEnabled
      )
        initCartOffer();
    } catch (err) {
      console.error(err);
    }
  }, { once: true });
})();
